import { apiClient } from '../apiClient';
import type { DocumotoPageDetailResponse, DocumotoPartsManualSearchResponse } from './types';

export type { DocumotoManualNodeDto, DocumotoPartsManualSearchResponse, DocumotoPageDetailResponse } from './types';

export function getDocumotoPartsManualSearch(serialNumber: string): Promise<DocumotoPartsManualSearchResponse> {
	const q = encodeURIComponent(serialNumber.trim());
	return apiClient.get<DocumotoPartsManualSearchResponse>(`/Documoto/parts-manual-search?serialNumber=${q}`);
}

export function getDocumotoPageDetails(entityId: string): Promise<DocumotoPageDetailResponse> {
	const q = encodeURIComponent(entityId.trim());
	return apiClient.get<DocumotoPageDetailResponse>(`/Documoto/page-details?entityId=${q}`);
}
